import { render, staticRenderFns } from "./UserRealTimeBox.vue?vue&type=template&id=80994404&"
import script from "./UserRealTimeBox.vue?vue&type=script&lang=js&"
export * from "./UserRealTimeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports